export default () => {

    Array.from(document.getElementsByClassName("with-sync-btn")).forEach(el => {
        el.addEventListener("click", (e) => {
            const form_element = el.closest("form")
            const hidden_element = document.createElement("input")
            hidden_element.setAttribute("type", "hidden")
            hidden_element.setAttribute("name", "store_platform_contract_workflow_for_edit[with_sync]")
            hidden_element.setAttribute("value", true)
            form_element.appendChild(hidden_element)
            HTMLFormElement.prototype.submit.call(form_element)
            form_element.removeChild(hidden_element)
        })
    })

    Array.from(document.getElementsByClassName('cancel_contract')).forEach(el => {
        el.addEventListener('click', (e) => {
            Array.from(document.getElementsByClassName('end_date')).forEach(el2 => {
                if(el2.value === '') {
                    el2.readOnly = false
                }
            })
        })
    })
}
